<template>
  <div class="page">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title"><span class="icon">Themed Tours</span></span>
      <HeaderNav />
    </div>

    <div v-if="pageData.acf" class="page-content">
      <Components :components="pageData.acf.components" location="above" />

      <div class="page-container">
        <div class="tour-grid list-container" v-if="this.pageData.acf.themed_tours.length">
          <div v-for="tour in this.pageData.acf.themed_tours" :key="tour.name" class="tour">
            <div class="tour-content">
              <img v-if="tour.featured_image" :src="tour.featured_image">
              <img v-if="tour.logo" :src="tour.logo" class="logo">
              <h2 class="tour-name">{{tour.name}}</h2>
              <div class="wysiwyg" v-html="tour.about"></div>
              <button class="btn" @click="$router.push(`/participants?themed_tour=${tour.name}`)">See Artists</button>
            </div>
          </div>
        </div>
      </div>

      <p class="post-list" v-if="this.pageData.acf.themed_tours.length === 0 && (filtersActive || search.length)">No results</p>
      <p class="post-list" v-else-if="this.pageData.acf.themed_tours.length === 0">Loading...</p>

      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';
import FiltersUtils from '../mixins/FiltersUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';

export default {
  name: 'ThemedTours',
  components: { Components, HeaderNav, Footer },
  mixins: [SubPageUtils, FiltersUtils],
  data() {
    return {
      pageData: {},
    }
  },
  computed: {
  },
  methods: {
  },
  async mounted() {
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/20513`);
    this.pageData = await pageDataResponse.json();
    console.log(this.pageData.acf.themed_tours)
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.icon {
  background-image: url(../assets/img/icon-artists.svg);
  background-size: 18px 21px;
}

.tour-grid {
  @grid-layout-gap: 50px;
  @grid-column-count: 3;
  @grid-item--min-width: 300px;

  @gap-count: calc(@grid-column-count - 1);
  @total-gap-width: calc(@gap-count * @grid-layout-gap);
  @grid-item--max-width: calc(100% - (@total-gap-width) / @grid-column-count);

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(max(@grid-item--min-width, @grid-item--max-width), 1fr));
  grid-gap: (@grid-layout-gap);

  margin: 50px 0;
  .tour {
    img {
      margin-bottom: 10px;
      max-width: 100%;
      object-fit: contain;
      &.logo {
        display: block;
        margin: 40px auto;
        max-width: 90%;
        height: 130px;
      }
    }
    span,
    p,
    a {
      display: block;
      margin-bottom: 8px;
      color: #000;
      text-decoration: none;
    }
    p {
      margin-bottom: 20px;
      &.tour-side {
        margin-bottom: 5px;
        font-size: 13px;
        font-weight: bold;
        text-transform: uppercase;
        color: @themeColor1;
      }
    }
    .tour-name {
      margin-bottom: 15px;
      font-size: 28px;
      text-align: center;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/ThemedTours.vue